import {ProductTileDefinition} from './productTile'

export {ProductTileDefinition}
